import axios from 'axios';

// Base URL konfigürasyonu
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://app.mobilassistance.com';

// Axios instance oluştur
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Token varsa header'a ekle
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Request log'u
    // console.log('API Request:', config.method?.toUpperCase(), config.url);
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Response log'u
    // console.log('API Response:', response.status, response.config.url);
    
    return response;
  },
  (error) => {
    // Error handling
    if (error.response) {
      // Server error response
      // console.error('API Error Response:', error.response.status, error.response.data);
      
      // 401 Unauthorized - Token expired
      if (error.response.status === 401) {
        localStorage.removeItem('authToken');
        // Redirect to login if needed
        // window.location.href = '/login';
      }
    } else if (error.request) {
      // Network error
      // console.error('API Network Error:', error.request);
    } else {
      // Other error
      // console.error('API Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// API endpoints
export const API_ENDPOINTS = {
  STATS: '/website-service/api/app/get-live-here',
  PACKAGES: '/website-service/api/app/packages',
  PACKAGE_PURCHASE: '/website-service/api/app/packages/purchase',
  CUSTOMER_INFO: '/website-service/api/app/customer/validate',
  VEHICLE_INFO: '/website-service/api/app/vehicle/validate',
  PAYMENT: '/website-service/api/app/payment/process',
  // Vehicle API endpoints
  VEHICLE_TYPE: '/website-service/api/Sale/get-vehicle-type',
  VEHICLE: '/website-service/api/Sale/get-vehicle',
  VEHICLE_MODEL: '/website-service/api/Sale/get-vehicle-model',
  MODEL_YEAR: '/website-service/api/Sale/get-model-year',
  // Package API endpoint
  PACKAGES_SALE: '/website-service/api/Sale/get-package',
  // Payment API endpoints
  SET_SALE: '/website-service/api/Sale/set-sale',
  VERIFY_3D_PAYMENT: '/website-service/api/Sale/verify-3d-payment',
  GET_CONTRACT_DATA: '/website-service/api/Sale/get-contract-data',
  GET_RECEIPT_DATA: '/website-service/api/Sale/get-receipt-data',
  // Package API endpoints for contract and voucher
  GET_CONTRACT: '/website-service/api/Package/get-contract',
  GET_VOUCHER: '/website-service/api/Package/get-voucher',

  //sms Validation
  ADD_SALES_WEB: '/website-service/api/Contact/add-sales-web',
  CHECK_PHONE: '/website-service/api/Contact/check-phone',
  SEND_SMS: '/website-service/api/App/send-sms',
  SEARCH_CONTRACT: '/website-service/api/App/search-contract',

  // Blog API endpoints
  GET_BLOGS: '/website-service/api/App/get-blogs',
  GET_BLOG_BY_ID: '/website-service/api/App/get-blog-with-id',

  // Services
  GET_SERVICES: '/website-service/api/App/get-services',
  GET_SERVICE_BY_ID: '/website-service/api/App/get-service-with-id',
  // Supplier Network
  GET_SUPPLIER_NETWORK: '/website-service/api/Supplier/get-supplier-network',
  GET_SUPPLIERS: '/website-service/api/Supplier/get-suppliers',
  GET_AUTO_INDUSTRY: '/yolyardim-service/api/Notification/get-auto-industry',

  // Çekici çağırma (CCN)
  GET_CITY: '/website-service/api/App/get-city',
  GET_DISTRICT: '/website-service/api/App/get-district',
  CCN_VEHICLE_TYPE: '/yolyardim-service/api/Price/ccn-vehicle-type',
  CCN_GET_PRICE: '/yolyardim-service/api/Price/get-price',
  CCN_SMS: '/yolyardim-service/api/Notification/sms-for-notification',
  CCN_ADD_NOTIFICATION: '/yolyardim-service/api/Notification/add-ccn-notification',
  CCN_SET_PAYMENT: '/yolyardim-service/api/Price/set-payment',
  CCN_VERIFY_3D: '/yolyardim-service/api/Price/verify-3d-payment',
};

// Stats API
export const statsAPI = {
  getLiveStats: () => api.get(API_ENDPOINTS.STATS),
};

// Packages API
export const packagesAPI = {
  getAll: () => api.get(API_ENDPOINTS.PACKAGES),
  getById: (id) => api.get(`${API_ENDPOINTS.PACKAGES}/${id}`),
  purchase: (data) => api.post(API_ENDPOINTS.PACKAGE_PURCHASE, data),
};

// Customer API
export const customerAPI = {
  validate: (data) => api.post(API_ENDPOINTS.CUSTOMER_INFO, data),
};

// Vehicle API
export const vehicleAPI = {
  getVehicleTypes: (mtChair) => api.post(`${API_ENDPOINTS.VEHICLE_TYPE}?mtChair=${mtChair}`),
  getVehicles: () => api.get(API_ENDPOINTS.VEHICLE),
  getVehicleModels: (dsBrandCode) => api.get(API_ENDPOINTS.VEHICLE_MODEL, { params: { dsBrandCode } }),
  getModelYears: (idCompany, idDealer) => api.get(API_ENDPOINTS.MODEL_YEAR, { params: { idCompany, idDealer } }),
};

// Package API
export const packageAPI = {
  getPackages: (packageData) => api.post(API_ENDPOINTS.PACKAGES_SALE, packageData),
};

// Payment API
export const paymentAPI = {
  setSale: (saleData) => api.post(API_ENDPOINTS.SET_SALE, saleData),
  verify3DPayment: (contractNo) => api.post(API_ENDPOINTS.VERIFY_3D_PAYMENT, { dsContractNo: contractNo }),
  getContractData: (orderNumber) => api.get(`${API_ENDPOINTS.GET_CONTRACT_DATA}?orderNumber=${orderNumber}`),
  getReceiptData: (orderNumber) => api.get(`${API_ENDPOINTS.GET_RECEIPT_DATA}?orderNumber=${orderNumber}`),
  // Yeni Package API fonksiyonları
  getContract: (dsPlate, dsTcNo) => api.get(`${API_ENDPOINTS.GET_CONTRACT}?dsPlate=${dsPlate}&dsTcNo=${dsTcNo}`),
  getVoucher: (dsContractNo) => api.get(`${API_ENDPOINTS.GET_VOUCHER}?dsContractNo=${dsContractNo}`),
};

// Dealer API
export const dealerAPI = {
  getCities: () => api.get('/website-service/api/App/get-city'),
  getDistricts: (cityId) => api.get(`/website-service/api/App/get-district?idCity=${cityId}`),
  createContact: (data) => api.post('/website-service/api/Dealer/new-contact', data),
  // SMS doğrulama için - aynı endpoint, farklı parametreler
  requestSMS: (phone) => api.post('/website-service/api/Dealer/verify-contact?dsPhone=' + phone),
  verifySMS: (phone, smsCode) => api.post('/website-service/api/Dealer/verify-contact?dsPhone=' + phone + '&dsSmsCode=' + smsCode, { 
    dsPhone: phone, 
    dsSmsCode: smsCode 
  }),
};
// Contact API
export const contactAPI = {
  addSalesWeb: (salesData) => api.post(API_ENDPOINTS.ADD_SALES_WEB, salesData),
  checkPhone: (phoneData) => {
    const params = new URLSearchParams({
      dsPhone: phoneData.dsPhone,
      dsSmsCode: phoneData.dsSmsCode
    });
    return api.post(`${API_ENDPOINTS.CHECK_PHONE}?${params.toString()}`);
  },
  sendSms: (idCompany, dsPhone) =>
    api.post(`${API_ENDPOINTS.SEND_SMS}?idCompany=${idCompany}&dsPhone=${encodeURIComponent(dsPhone)}`),
  sendMessage: (payload) =>
    api.post('/website-service/api/Contact/new-message', payload),
};

// Sözleşme arama API
export const contractSearchAPI = {
  search: (data) => api.post(API_ENDPOINTS.SEARCH_CONTRACT, data),
};

// Blog API
export const blogAPI = {
  getBlogs: () => api.get(API_ENDPOINTS.GET_BLOGS),
  getBlogById: (idBlog) => api.get(`${API_ENDPOINTS.GET_BLOG_BY_ID}?idBlog=${idBlog}`),
};

// Services API
export const servicesAPI = {
  getServices: (params = {}) => api.get(API_ENDPOINTS.GET_SERVICES, { params }),
  getServiceById: (idServices) =>
    api.get(`${API_ENDPOINTS.GET_SERVICE_BY_ID}?idServices=${idServices}`),
};

// Supplier API
export const supplierAPI = {
  getSupplierNetwork: () => api.get(API_ENDPOINTS.GET_SUPPLIER_NETWORK),
  getSuppliers: ({ idCity, idDistrict }) =>
    api.get(API_ENDPOINTS.GET_SUPPLIERS, { params: { idCity, idDistrict } }),
  getAutoIndustry: ({ idCity, idDistrict }) =>
    api.get(API_ENDPOINTS.GET_AUTO_INDUSTRY, { params: { idCity, idDistrict } }),
};

const unwrapData = (payload) => {
  if (!payload) return null
  return payload.data ?? payload.Data ?? null
}

const getStatusCode = (payload, httpStatus) => {
  const status = payload?.statu ?? payload?.Statu
  if (typeof status === 'number') return status
  if (status && typeof status === 'object') {
    const code = status.statusCode ?? status.StatusCode
    if (code != null) return Number(code)
  }
  return httpStatus != null ? Number(httpStatus) : null
}

const readStatusMessage = (payload, fallback) => {
  const status = payload?.statu ?? payload?.Statu
  const exceptions = payload?.exceptions || payload?.Exceptions
  if (status && typeof status === 'object') {
    if (status.description) return status.description
    if (status.message) return status.message
  }
  if (Array.isArray(exceptions) && exceptions.length > 0) {
    const first = exceptions[0]
    if (typeof first === 'string') return first
    if (first?.message) return first.message
    if (first?.Message) return first.Message
  }
  if (payload?.errors?.dsSmsCode) {
    const smsError = payload.errors.dsSmsCode
    return Array.isArray(smsError) ? smsError[0] : String(smsError)
  }
  return fallback
}

const isSuccessStatus = (payload, httpStatus = 200) => {
  const code = getStatusCode(payload, httpStatus)
  return code === 200 || code === null
}

export const cekiciAPI = {
  getCities: () => api.get(API_ENDPOINTS.GET_CITY),
  getDistricts: (idCity) =>
    api.get(API_ENDPOINTS.GET_DISTRICT, { params: { idCity } }),
  getVehicleTypes: () => api.get(API_ENDPOINTS.CCN_VEHICLE_TYPE),
  getAutoIndustry: (idCity) =>
    api.get(API_ENDPOINTS.GET_AUTO_INDUSTRY, {
      params: { idCity, idDistrict: 0 },
    }),
  getPrice: (payload) =>
    api.post(API_ENDPOINTS.CCN_GET_PRICE, payload, { timeout: 30000 }),
  sendSms: (idCompany, dsPhone) =>
    api.post(
      `${API_ENDPOINTS.CCN_SMS}?idCompany=${idCompany}&dsPhone=${encodeURIComponent(dsPhone)}`
    ),
  addNotification: (payload) =>
    api.post(API_ENDPOINTS.CCN_ADD_NOTIFICATION, payload, { timeout: 30000 }),
  setPayment: (payload) =>
    api.post(API_ENDPOINTS.CCN_SET_PAYMENT, payload, { timeout: 60000 }),
  verify3dPayment: (payload) =>
    api.post(API_ENDPOINTS.CCN_VERIFY_3D, payload, { timeout: 30000 }),
  unwrapData,
  getStatusCode,
  readStatusMessage,
  isSuccessStatus,
};

export default api; 